exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-13eab214]:export {\n  xrColorPrimary: #2362FB;\n}\n.map[data-v-13eab214] {\n  height: 150px;\n  width: 100%;\n  overflow: hidden;\n  margin-top: 5px;\n}\n.area-title[data-v-13eab214] {\n  font-size: 12px;\n  color: #aaa;\n  padding-bottom: 10px;\n}\n.distpicker-address-wrapper[data-v-13eab214] select {\n  height: 34px;\n  font-size: 12px;\n  border-radius: 0.1rem;\n}\n[data-v-13eab214] .el-dialog__body {\n  padding: 10px 20px 20px;\n}\n", ""]);

// exports
